import 'bootstrap';
import $ from 'jquery';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import 'slick-carousel';

// load components
import Common from './components/common';
import Layout from './components/layout';
import Validation from './components/validation';
import LoanOfficerLanding from './components/loanOfficerLanding';
import ReverseMortgageCalculator from './components/reverseMortgageCalculator';
import LoanServicing from './components/loanServicing';
import ExternalLinkEditor from './components/externalLinkEditor';
import NewUserRegistration from './components/newUserRegistration';
import './components/calculators';
import { initDisclosureNavigation } from './components/disclosureNavigation';
import { initInlineLists } from './components/inlineList';

$(document).ready(e => {
    initDisclosureNavigation();
    initInlineLists();
	let common = new Common();
    common.init();

    let layout = new Layout();
    layout.init();

    let validation = new Validation();
    validation.init();

    let loanOfficerLanding = new LoanOfficerLanding();
    loanOfficerLanding.init();

    let reverseMortgageCalculator = new ReverseMortgageCalculator();
    reverseMortgageCalculator.init();

    let loanServicing = new LoanServicing();
    loanServicing.init();

    let externalLinkEditor = new ExternalLinkEditor();
    externalLinkEditor.init();

    let newUserRegistration = new NewUserRegistration();
    newUserRegistration.init();
});
